import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Title = styled(Box)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '2.5rem',
  color: 'white',
  lineHeight: '130%',
  [theme.breakpoints.down('sm')]: {
    // 600px 이하
    fontWeight: 300,
    fontSize: '1.5rem',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    // 600px 이상 900px 이하
    fontSize: '1.8rem',
  },
}));

export const TitleBold = styled(Box)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '3rem',
  lineHeight: '130%',
  [theme.breakpoints.down('sm')]: {
    // 600px 이하
    fontSize: '2rem',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    // 600px 이상 900px 이하
    fontSize: '2.2rem',
  },
}));

export const Sub = styled(Box)(({ theme }) => ({
  fontWeight: 300,
  fontSize: '1.5rem',
    color: 'white',
  lineHeight: '140%',
  letterSpacing: '-0.72px',
  [theme.breakpoints.down('sm')]: {
    // 600px 이하
    fontWeight: 500,
    fontSize: '0.75rem',
    lineHeight: '1rem',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    // 600px 이상 900px 이하
    fontSize: '1.1rem',
  },
}));

export const SubBold = styled('span')(({ theme }) => ({
  fontWeight: 500,
  fontSize: '1.5rem',
  [theme.breakpoints.down('sm')]: {
    // 600px 이하
    fontWeight: 700,
    fontSize: '0.75rem',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    // 600px 이상 900px 이하
    fontSize: '1.1rem',
  },
}));
